module.exports = __webpack_public_path__ + "static/img/1_4_2.2f887f25.jpg";